
// config object that contains the configuration of the search bar
let config = {
    searchBar: document.querySelector('.beneficiary-search-bar'),
}

config.resultsContainer = config.searchBar.getAttribute('data-resultsid') ? 
document.querySelector(`#${config.searchBar.getAttribute('data-resultsid')}`) : 
document.querySelector('#org-results-container')

config.filters = config.searchBar.getAttribute('data-filters') ? true : false

config.parent = config.searchBar.getAttribute('data-parent') ? config.searchBar.getAttribute('data-parent') : null

config.resultsClass = config.searchBar.getAttribute('data-resultsclass') ? config.searchBar.getAttribute('data-resultsclass') : null

config.linkType = config.searchBar.getAttribute('data-linktype') ? config.searchBar.getAttribute('data-linktype') : null

config.linkCustom = config.searchBar.getAttribute('data-linkcustom') ? config.searchBar.getAttribute('data-linkcustom') : null

config.buttonText = config.searchBar.getAttribute('data-buttontext') ? config.searchBar.getAttribute('data-buttontext') : null

config.context = config.searchBar.getAttribute('data-context') ? config.searchBar.getAttribute('data-context') : 'page'

config.autoLoad = config.searchBar.getAttribute('data-autoload') ? true : false


// function thats loads the items from the server and renders them
async function loadItems(){

    const {resultsContainer, parent, filters, resultsClass, linkType, linkCustom, buttonText, context } = config

    // delete placeholder
    if(document.querySelector('#org-results-defaults')){
        document.querySelector('#org-results-defaults').style.display = "none"
    }

    // clear previous results
    resultsContainer.innerHTML = ""

    // create loading animation
    let resultsCustomNoResults=document.querySelector('#org-results-noresults');
    let resultsCustomPreloader=document.querySelector('#org-results-loader');
    if(resultsCustomPreloader){
        resultsCustomPreloader.style.display="block";
    } else {
        if(!document.querySelector("#loaderAnim")){
            let elem = document.createElement('div')
            elem.id = "loaderAnim"
            elem.classList.add('text-center', 'big-top-margin')
            elem.innerHTML = '<span class="fa fa-2x fa-refresh fa-spin"></span>'
    
            resultsContainer.appendChild(elem)
        }
    }

    try{
        
        // api request to get the items
        let apiUrl = "/api/v2/organizations-search/"

        if(window.location.search !== "") {
            apiUrl += window.location.search
        }

        apiUrl += parent ? `&parent=${parent}` : ""

        const response = await fetch(apiUrl, {
            method: 'GET',
            headers: {
                accept: 'application/json'
            },
        });

        if(response.status !== 200){
            throw new Error('Error while fetching data from the server')
        }

        const data = await response.json();        

        // render search tags if needed
        /*
        if(filters){
            // create search tags container
            let tags = document.createElement('div')
            tags.classList.add('criteria-labels')

            // map through the search params
            let searchParams = new URLSearchParams(window.location.search)
            searchParams.forEach((value, key) => {

                // if it is filter make sure that it is checked in the list
                if(key !== "keywords" && key !== "page"){
                    document.querySelector(`#${key.replaceAll("_", "")}${value}`).checked = true
                }

                // create element if its not a page param
                if(key !== "page") {

                    let tag = document.createElement('div')
                    tag.classList.add('criteria')
                    tag.innerHTML = `<span class="name">${key === "keywords" ? value : document.querySelector(`label[for=${key.replaceAll("_", "")}${value}]`).innerText}</span>
                    <div class="close" data-type="${key}" data-value="${value}"></div>`

                    // add event listener to the close button
                    tag.querySelector('.close').addEventListener('click', (e) => {

                        let searchParams = new URLSearchParams(window.location.search)
                        searchParams.delete(e.target.getAttribute('data-type'), e.target.getAttribute('data-value'))
                        searchParams.delete("page")
                        window.history.pushState({}, null,  `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`)

                        if(e.target.getAttribute('data-type') !== "keywords" && key !== "page"){
                            document.querySelector(`#${key.replaceAll("_", "")}${value}`).checked = false
                        }

                        loadItems()
                    })

                    tags.appendChild(tag)
                }
            })

            resultsContainer.appendChild(tags)
        }
        */

        // create results container
        let results = document.createElement('div')
        results.classList.add('results', "row", "organizations")
        if(typeof(resultsClass)=='string'){
            let resultsClass2=resultsClass.split(' ');
            results.classList.add(...resultsClass2);
        }
        

        // map through the results items
        if(data.organizations.count > 0){
            // render the items
            data.organizations.items.forEach((i) => {

                // create item element
                let orgItem = document.createElement('div')

                if(context === "modal"){
                    orgItem.classList.add('col-6', 'col-sm-3', 'col-md-3', 'result', 'result-inline', 'organization')
                    orgItem.innerHTML = `<div class="resultInner"><div class="wrap"><a href="${linkType === "custom" ? `${linkCustom}${linkCustom.includes('?') ? '&' : '?'}beneficiary_id=${i.id}` : i.url}">
                    <div class="image-wrap-new" style="background-image: url(${(i.main_image ? i.main_image : STATIC_URL+'img/no-image.png')}); background-position: center center; background-size: contain; background-repeat: no-repeat;">
                    </div><p class="name">${i.name}</p> ${buttonText ? `<div class="overlay">
                    span class="btn btn-red">data-analytics="beneficiary_choose" data-analytics-value="${i.id}">${buttonText}</span></div></a></div></div>` : "</a></div></div>"}`
                } else {
                    orgItem.classList.add('col')
                    orgItem.innerHTML = `
                        <div class="card h-100 card-beneficiary">
                            <div class="card-body">
                                <div class="beneficiary-logo">
                                    <img src="${(i.main_image ? i.main_image : STATIC_URL+'img/no-image.png')}"/>
                                </div>
                                <h5 class="card-title">${i.name}</h5>
                                <p class="card-text beneficiary-description">${i.description.substring(0,200)}</p>
                                <a href="${i.url}" class="btn btn-secondary text-uppercase stretched-link">${window.jsLocale.search_more}</a>
                                <span class="card-beneficiary-icon card-beneficiary-icon-${i.field_of_action_slug} "></span>
                            </div>
                        </div>
                    `;
                }
                results.appendChild(orgItem)
            })
            if(resultsCustomNoResults){
                resultsCustomNoResults.style.display="none";
            }
        }else{
            if(resultsCustomNoResults){
                resultsCustomNoResults.style.display="block";
            } else {
                // create no results message
                results.innerHTML = `
                <div class="col-12 text-center">
                <p>${window.jsLocale.search_noresults_1}</p>
                <p>${window.jsLocale.search_noresults_2}</p>
                </div>`
            }
        }
        resultsContainer.appendChild(results)

        // create pagination if needed
        if(data.organizations.max_pages > 1){

            // create ui element
            let elem = document.createElement('div')
            elem.classList.add('col-xs-12')
            elem.innerHTML = `<nav>
            <ul class="pagination justify-content-center mt-2">
            <li class="${!data.organizations.previous && "disabled"} arrow page-item" data-pagination-nextprev="previous" aria-label="${window.jsLocale.pagination_prev}">
            <span class="link page-link">&lt;</span>
            </li>
            <li class="page-item disabled dotted">
            <span class="page-link page-text">${window.jsLocale.pagination_page} ${data.organizations.page} ${window.jsLocale.pagination_of} ${data.organizations.max_pages}</span>
            </li>
            <li class="${!data.organizations.next && "disabled"} arrow page-item" data-pagination-nextprev="next" aria-label="${window.jsLocale.pagination_next}">
            <span class="link page-link">&gt;</span>
            </li></ul></nav>`
            
            // event handler for page buttons
            let changePage = (e) => {
                if(Array.from(e.currentTarget.classList).indexOf('disabled') === -1){
                    let linkToApi = data.organizations[e.currentTarget.attributes['data-pagination-nextprev'].value.toLowerCase()]
                    let newUrl = `${window.location.origin}${window.location.pathname}${linkToApi.slice(linkToApi.indexOf('?'))}`
                    window.history.pushState({}, null, newUrl )
                    context === "modal" ? document.querySelector('#beneficiary-select-modal-abovesearchresults').parentElement.scrollTo({top: document.querySelector('#beneficiary-select-modal-abovesearchresults').offsetHeight, left: 0, behavior: "smooth"}) : window.scrollTo(0,0)
                    loadItems()
                }
            }   

            // add event listeners
            elem.querySelector('li[data-pagination-nextprev="previous"]').addEventListener('click', changePage)
            elem.querySelector('li[data-pagination-nextprev="next"]').addEventListener('click', changePage)


            resultsContainer.appendChild(elem)
        }

        // remove loader
        if(resultsCustomPreloader){
            resultsCustomPreloader.style.display="none";
        } else {
            document.querySelector("#loaderAnim").remove()
        }
        

    }catch(e){

        console.error('error', e)

        // clear results if errour occured
        resultsContainer.innerHTML = ""

        // show defualt results
        if(document.querySelector('#org-results-defaults')){
            document.querySelector('#org-results-defaults').style.display = "block"
            document.querySelector('#org-results-noresults').style.display = "none"
        }

        

        if(resultsCustomPreloader){
            console.log('resultsCustomPreloader hide')
            resultsCustomPreloader.style.display="none";
        } else {
            document.querySelector("#loaderAnim").remove()
        }
    }

}

// load items if autoload is set to true
if(config.autoLoad) loadItems()

// function that handles the search bar
async function searchBarHandler(){

    const {searchBar} = config

    // if keywords are already in the url populate the search bar
    let searchParams = new URLSearchParams(window.location.search)
    if(searchParams.has("keywords")){
        searchBar.querySelector('input').value = searchParams.get("keywords")
    }

    // add event listener to the search bar
    searchBar.addEventListener('submit', async (e) => {

        e.preventDefault()

        let searchParams = new URLSearchParams(window.location.search)
        
        // check if the input value is empty
        if(e.target.querySelector('input').value.trim().length > 0){

            // delete previous page param
            searchParams.delete("page")

            // add param to the url
            searchParams.set("keywords", e.target.querySelector('input').value.trim())
            window.history.pushState({}, null,  `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`)

            // load search results
            loadItems()

        }else{

            // remove param from the url
            searchParams.delete("keywords")
            window.history.pushState({}, null,  `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`)

            // load search results
            loadItems()

        }
    })

    // delete loading animation
    searchBar.querySelector('.loading-overlay').remove()
    searchBar.querySelector('.btn').removeAttribute('disabled')
    searchBar.removeAttribute('disabled')

}   

searchBarHandler()

// function that handles the filters
async function filtersHandler(){

    let filtersDropdown=document.getElementById('benefiary-search-dropdown-button');

    // map through the checkboxes
    document.querySelectorAll('.form-check-input').forEach((i) => {

        // add event listener to the checkboxes
        i.addEventListener('change', async (e) => {

            // get the search params
            let searchParams = new URLSearchParams(window.location.search)

            // check the type of the checkbox
            let type = ""
            switch (e.target.id.slice(0, 3)){
                case "fie":
                    type = "fields_of_action"
                    break;
                case "geo":
                    type = "geographical_scopes"
                    break; 
            }

            // add or remove the param from the url
            if(e.target.checked){
                searchParams.delete(type)
                if(e.target.value>0){
                    searchParams.append(type, e.target.value)
                    if(filtersDropdown){
                        //Change the button's value?
                        //filtersDropdown.textContent = e.target.getAttribute('data-name');
                    }
                } else {
                    if(filtersDropdown){
                        //Change the button's value?
                        //filtersDropdown.textContent = filtersDropdown.getAttribute('data-default-value');
                    }
                }
            }else{
                searchParams.delete(type, e.target.value)
            }
            searchParams.delete("page")


            window.history.pushState({}, null,  `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`)

            loadItems()
        })
    })
}

if(config.filters) filtersHandler()